const image = document.querySelector(".product-ingredients-image");
const dotsContainer = document.getElementById("dots-container");
const imageContainer = document.querySelector(".product-ingredients-image-container");
const dotsLength = dotsContainer.getAttribute("data-dotsLength");
const numberOfDots = dotsLength;
let startAngle, endAngle;

if (window.innerWidth > 999) {
  startAngle = -40;  // Start angle for screen width more than 700px
  endAngle = 40;     // End angle for screen width more than 700px
} else {
  startAngle = 140;  // Start angle for screen width less than or equal to 700px
  endAngle = 40;     // End angle for screen width less than or equal to 700px
}
const angleIncrement = (endAngle - startAngle) / (numberOfDots - 1);

function positionDots() {
  dotsContainer.innerHTML = ''; // Clear previous dots

  // Get the radius including the image size and the outline offset (27px)
  const radius = (imageContainer.offsetWidth / 2); // Updated radius with 27px offset

  // Calculate center of the image container for relative positioning
  const centerX = imageContainer.offsetWidth / 2;
  const centerY = imageContainer.offsetHeight / 2;

  // Calculate dot positions along the outline
  for (let i = 0; i < numberOfDots; i++) {
    const angle = startAngle + i * angleIncrement;
    const angleRad = (angle * Math.PI) / 180;

    // Calculate x and y positions based on the angle
    const x = centerX + radius * Math.cos(angleRad);
    const y = centerY + radius * Math.sin(angleRad);

    const dot = document.createElement("div");
    dot.classList.add("dot");
    dot.style.position = 'absolute';
    dot.style.left =`${x}px` ;
    dot.style.top = `${y}px`;
    dot.style.transform = 'translate(-50%, -50%)'; // Center the dot

    // SVG content for the dot
     dot.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
        <g id="Ellipse 51">
          <circle cx="9.10236" cy="9.54461" r="7.00408" transform="rotate(90 9.10236 9.54461)" fill="#FCF8F0"/>
          <circle cx="9.10236" cy="9.54461" r="8.00408" transform="rotate(90 9.10236 9.54461)" stroke="#1E4B3C" stroke-opacity="0.4" stroke-width="2"/>
        </g>
      </svg>
    `;
  

    dotsContainer.appendChild(dot);
  }
}

// Initial positioning and adjust on window resize
positionDots();
// window.addEventListener("resize", positionDots);

document.addEventListener("DOMContentLoaded", function() {
  const mediaQuery = window.matchMedia("(min-width: 1180px)");

  function applyHeight() {
    const mainContainer = document.querySelector('.product-ingredients-image-container');
    const textContainer = document.querySelector('.product-ingredients-text-container');

    if (mainContainer && textContainer) {
      if (mediaQuery.matches) {
        textContainer.style.height = `${mainContainer.offsetHeight}px`;
      } else {
        textContainer.style.height = ""; // Reset height if below 700px
      }
    }
  }

  // Initial check
  applyHeight();

  // Listen for window resize to apply/remove height based on media query
  mediaQuery.addListener(applyHeight);

  // Use ResizeObserver to observe changes in the mainContainer height
  const mainContainer = document.querySelector('.product-ingredients-image-container');
  if (mainContainer) {
    const resizeObserver = new ResizeObserver(() => {
      applyHeight();
    });
    resizeObserver.observe(mainContainer);
  }
});


document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth > 999) {
    const items = document.querySelectorAll('.product-ingredients__item');
    const numItems = items.length;

    // Fixed margin sequence for 4 elements
    if (numItems === 4) {
      const margins = [0, 40, 40, 0];
      items.forEach((item, index) => {
        item.style.marginLeft = `${margins[index]}px`;
      });
    }
    // For 6 elements, manually set margins
    else if (numItems === 6) {
      const margins = [0, 51, 102, 102, 51, 0];
      items.forEach((item, index) => {
        item.style.marginLeft = `${margins[index]}px`;
      });
    }
  }
});



// Function to handle the hover effect and automatic selection cycle
const handleHoverEffect = () => {
  const dots = document.querySelectorAll('.dot');
  const ingredientsItems = document.querySelectorAll('.product-ingredients__item');
  let currentIndex = 0; // Track the current index for the cycle

  // Function to handle the auto-cycle
  const cycleDots = () => {
    // Remove 'selected' class and scale reset from all dots and items
    dots.forEach(dot => dot.classList.remove('selected'));
    ingredientsItems.forEach(item => item.style.transform = 'scale(1)');

    // Add 'selected' class and scale to the current index
    dots[currentIndex].classList.add('selected');
    ingredientsItems[currentIndex].style.transform = 'scale(1.05)';

    // Update the index for the next cycle
    currentIndex = (currentIndex + 1) % dots.length;
  };

  // Check if the screen width is more than 1000px
  if (window.matchMedia('(min-width: 1000px)').matches) {
    // Add hover listeners if screen is larger than 700px
    dots.forEach((dot, index) => {
      dot.addEventListener('mouseenter', () => {
        clearInterval(autoCycle); // Stop auto-cycle on hover
        dots.forEach(d => d.classList.remove('selected'));
        ingredientsItems.forEach(item => item.style.transform = 'scale(1)');
        dot.classList.add('selected');
        ingredientsItems[index].style.transform = 'scale(1.05)';
      });

      dot.addEventListener('mouseleave', () => {
        autoCycle = setInterval(cycleDots, 1000); // Restart auto-cycle on hover out
      });
    });

    // Set up the interval for auto-cycling through dots
    let autoCycle = setInterval(cycleDots, 1000);
    cycleDots(); // Start immediately at the 0th second

    // Handle window resize to reinitialize the hover effect and auto-cycle
    // window.addEventListener('resize', () => {
    //   clearInterval(autoCycle); // Stop the cycle on resize
    //   if (window.matchMedia('(min-width: 1000px)').matches) {
    //     handleHoverEffect(); // Re-run the function if screen is still above 700px
    //   }
    // });
  }
};

// Call the function on page load
handleHoverEffect();





let autoCycle = null;  // Declare autoCycle to persist across calls
let currentIndex = 0;  // Track the current index for the auto-cycle
let restartTimeout = null;  // Store the reference to the setTimeout

// Function to handle the auto-cycle
const cycleDotsMobile = () => {
  const dots = document.querySelectorAll('.dot');
  const ingredientsItems = document.querySelectorAll('.product-ingredients__item');

  // Hide all product-ingredients__item elements and remove 'selected' class
  ingredientsItems.forEach(item => {
    item.classList.remove('selected'); // Remove selected class from all items
  });

  // Remove 'selected' class from all dots
  dots.forEach(dot => dot.classList.remove('selected'));

  // Display and highlight the current dot and item
  ingredientsItems[currentIndex].style.display = 'flex';
  ingredientsItems[currentIndex].classList.add('selected'); // Add selected class to the current item
  dots[currentIndex].classList.add('selected'); // Add selected class to the dot

  // Update the index for the next cycle
  currentIndex = (currentIndex + 1) % dots.length;
};

const handleDotClick = () => {
  const dots = document.querySelectorAll('.dot');
  const ingredientsItems = document.querySelectorAll('.product-ingredients__item');

  if (window.matchMedia('(max-width: 999px)').matches) {
    dots[0].classList.add('selected');
    ingredientsItems[0].classList.add('selected'); // Add selected class to the first item

    // Clear existing intervals
    if (autoCycle) {
      clearInterval(autoCycle);
      autoCycle = null;
    }

    autoCycle = setInterval(cycleDotsMobile, 2500);
    cycleDotsMobile();

    // Loop through each dot for click functionality
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        // Stop the auto-cycle on click
        if (autoCycle) {
          clearInterval(autoCycle);
          autoCycle = null;
        }

        // Clear the restart timeout if it exists
        if (restartTimeout) {
          clearTimeout(restartTimeout);
          restartTimeout = null;
        }

        // Hide all product-ingredients__item elements
        ingredientsItems.forEach(item => {
          item.classList.remove('selected');
        });

        // Show the corresponding product-ingredients__item
        ingredientsItems[index].classList.add('selected');

        // Remove 'selected' class from all dots and add it to the clicked one
        dots.forEach(dot => dot.classList.remove('selected'));
        dot.classList.add('selected');

        // Update the currentIndex to the clicked dot's index
        currentIndex = index;

        // Restart the auto-cycle after 5 seconds
        restartTimeout = setTimeout(() => {
          autoCycle = setInterval(cycleDotsMobile, 2500);
          cycleDotsMobile();
        }, 5000); // 5 seconds delay
      });
    });
  } else {
    // Clear interval when not on mobile
    if (autoCycle) {
      clearInterval(autoCycle);
      autoCycle = null;
    }
  }
};

// Call the function on page load
handleDotClick();

// Re-run the function whenever the window is resized
// window.addEventListener('resize', handleDotClick);






// Function to adjust container height based on the tallest child
function adjustContainerHeight() {
    const container = document.querySelector('.product-ingredients-text-container');
    const items = container.querySelectorAll('.product-ingredients__item');

    // Check if the screen width is 999px or less
    if (window.matchMedia('(max-width: 999px)').matches) {
        let maxHeight = 0;

        // Find the maximum height among all children
        items.forEach(item => {
            maxHeight = Math.max(maxHeight, item.offsetHeight);
        });

        // Apply the tallest height to the parent container
        container.style.minHeight = `${maxHeight}px`;
        // container.style.setProperty('height', `${maxHeight}px`, 'important');

        console.log(maxHeight);
    } else {
        // Reset height for wider screens
        container.style.height = '';
    }
}

// Run the function on page load and window resize
adjustContainerHeight();
// window.addEventListener('resize', adjustContainerHeight);

